import { jsx as _jsx } from "react/jsx-runtime";
import { ElementOrIllustration } from '../../components/elementOrIllustration/elementOrIllustration';
import { IconHighlighted } from '../../components/iconHighlighted/iconHighlighted';
import { ElementOrIcon } from '../elementOrIcon/elementOrIcon';
import { DecorativeElementType } from './types/DecorativeElementType';
const ELEMENT_TYPE_TO_ELEMENT_MAP = {
    [DecorativeElementType.ICON]: ElementOrIcon,
    [DecorativeElementType.ICON_HIGHLIGHTED]: IconHighlighted,
    [DecorativeElementType.ILLUSTRATION]: ElementOrIllustration,
};
export const DecorativeElement = ({ elementType, ...props }) => {
    const DecorativeElement = ELEMENT_TYPE_TO_ELEMENT_MAP[elementType];
    // @ts-expect-error - props type is already defined because of the XOR definition in IDecorativeElement
    return _jsx(DecorativeElement, { ...props });
};
//# sourceMappingURL=decorativeElement.js.map